import {useState} from 'react';
import {useNavigate} from 'react-router';
import {CheckCircleOutlined, CheckOutlined, CopyOutlined, SendOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client/react';
import {Button, Space} from 'antd';
import {observer} from 'mobx-react-lite';

import {MyModal} from '../../../../components/common/MyModal';
import {CREATE_USER} from '../../../../shared/graphql/admin/users';
import generatePassword from '../../../../shared/helpers/generatePassword';
import {phoneToPlain} from '../../../../shared/helpers/phoneFormat';
import {emailFromForm} from '../../../../shared/helpers/userEmail';

import {IUser,UserForm} from './UserForm';

import cls from './User.module.scss'

export const UserNew = observer(() => {

    const [message, setMessage] = useState<string>('')
    // const [phone, setPhone] = useState<string>('')
    // const [password, setPassword] = useState<string>('')
    const [open, setOpen] = useState<boolean>(false)
    const [copied, setCopied] = useState<boolean>(false)
    
    const initValues: IUser = {
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: generatePassword(),
        role: 'parent',
    }

    const [createUser] = useMutation(CREATE_USER)
    const navigate = useNavigate()

    const onFinish = async (data: IUser) => {

        await createUser({
            variables: {
                data: {
                    ...data,
                    username: phoneToPlain(data.username),
                    email: emailFromForm(data.email, phoneToPlain(data.username)),
                    role: data.role === 'admin' ? '3' : '1',
                    provider: 'local',
                }
            },
            onCompleted: () => {
                // setLogin(data.username)
                // setPassword(data.password!)
                setMessage(`Добрый день! 
Вы зарегистрированы в системе оплаты питания Proschool.
Для пополнения баланса питания ребенка вам необходимо перейти по ссылке:
https://class.proschoolnsk.ru

Логин: ${data.username}
Пароль: ${data.password}

Инструкция по оплате питания:
https://class.proschoolnsk.ru/instruction.pdf`)
                // setPhone(phoneToPlain(data.username))
                setOpen(true)
            },
        })
    }

    const onCopy = async () => {
        await navigator.clipboard.writeText(message);
        setCopied(true)
    }

    return <>
        <UserForm values={initValues} action={'Сохранить'} onFinish={onFinish} pwd/>
        <MyModal isOpen={open} onClose={() => navigate(-1)} className={cls.modal}>
            <Space direction={'vertical'}>
                <div className={cls.icon}>
                    <CheckCircleOutlined/> Успешно
                </div>

                <div>
                    Пароль виден только на этом экране, посмотреть повторно не получится, но можно установить новый.
                    Отправьте приветственное сообщение с логином и паролем.
                </div>

                <pre className={cls.message}>
                    {message}
                </pre>

                <Space>
                    <Button type={'primary'} size={'large'} onClick={onCopy} icon={copied ? <CheckOutlined/> : <CopyOutlined/>}>Скопировать</Button>
                    <a href={encodeURI('https://t.me/+YkMxuY0koWxjZWNi')} target={'_blank'} rel={'noreferrer'}>
                        <Button size={'large'} onClick={() => navigate(-1)} icon={<SendOutlined/>}>Перейти
                            в группу</Button>
                    </a>
                </Space>


            </Space>
        </MyModal>
    </>

})